module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "co-info",
    attrs: {
      "span": 20
    }
  }, [_c('ul', {
    staticClass: "co-links clearfix"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "http://www.18show.cn/r?gsZHb",
      "target": "_blank"
    }
  }, [_vm._v("关于我们")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.18show.cn/r?4sZHb",
      "target": "_blank"
    }
  }, [_vm._v("易展动态")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.18show.cn/r?CsZHb",
      "target": "_blank"
    }
  }, [_vm._v("易展荣誉")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.18show.cn/r?LsZHb",
      "target": "_blank"
    }
  }, [_vm._v("易展服务")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.18show.cn/r?WsZHb",
      "target": "_blank"
    }
  }, [_vm._v("易家文化")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.18show.cn/r?GtZHb",
      "target": "_blank"
    }
  }, [_vm._v("英才集结号")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.18show.cn/r?euZHb",
      "target": "_blank"
    }
  }, [_vm._v("社会责任")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.18show.cn/r?N5Oeb",
      "target": "_blank"
    }
  }, [_vm._v("联系我们")])])]), _vm._v(" "), _c('p', [_vm._v("备案号：粤ICP备11010883号-1 公安机关备案号：44040202000312 本站所有关键词指数仅供参考，最终解释权归易展所有")]), _vm._v(" "), _c('p', [_vm._v("Copyright©2004-2017  珠海市金信桥网络科技有限公司 版权所有")])]), _vm._v(" "), _c('el-col', {
    staticClass: "co-logo",
    attrs: {
      "span": 4
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d81a4f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/footer.vue
// module id = 183
// module chunks = 2